import React from 'react';
import { ConfigProvider, theme } from 'antd';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { PersistGate } from 'redux-persist/integration/react';
import Navigation from './screens/navigation/Navigation';
import reduxStore from './utils/redux/store';

const App = () => {
  return (
    <Provider store={reduxStore.store}>
      <PersistGate loading={null} persistor={reduxStore.persistor}>
        <ConfigProvider
          theme={{
            algorithm: theme.darkAlgorithm,
          }}
        >
          <HelmetProvider>
            <BrowserRouter basename='/' window={window}>
              <Navigation />
            </BrowserRouter>
          </HelmetProvider>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
